import { API } from '@/utils/api'
import Vue from 'vue'

/**
 * @typedef {typeof import('./state').default} State
 */

const modifyNotification = notification => {
  // isNew is only for notifications that arrive over WS
  notification.isNew = false
  return notification
}

/**
 * @type {Record<string, (ctx: { state: State }, ...args: any) => any}
 */
export default {
  load(context, forceReset = false) {
    context.commit('setIsLoading', true)

    const args = {
      mode: context.state.mode,
    }

    if (!forceReset) {
      args.cursor = context.getters.cursor
    }

    const promises = [
      API.call('/$v/notification/list.json', args),
      ...(forceReset ? [API.call('/$v/notification/unread_count.json')] : [])
    ]


    return Promise.all(promises)
      .then(([listResponse, unreadCountResponse]) => {
        listResponse.data = listResponse.data.map(modifyNotification)

        context.commit('setHasMore', listResponse.has_more)
        context.commit(
          'setNotifications',
          forceReset ? listResponse.data : context.state.notifications.concat(listResponse.data)
        )

        if (forceReset) {
          context.commit('setUnread', unreadCountResponse.data)
        }
      })
      .finally(() => {
        context.commit('setIsLoading', false)
      })
  },

  toggleMode(context, mode = 'unread') {
    context.commit('setMode', mode)
    context.dispatch('load', true)
  },

  addOne(context, notification) {
    const { notification_id } = notification
    if (
      context.state.notifications
      .some(notification => notification.notification_id === notification_id)
    ) {
      return false
    }

    notification.isNew = true
    context.commit('addOne', notification)
    context.commit('incUnread')
    return true
  },

  setIsListOpen(context, isOpen) {
    context.commit('setIsListOpen', isOpen)
  },

  ack(context, args) {
    return API.call('/$v/notification/ack.json', {
      all: args.all,
      notification_id: args.notification_id
    }).then(r => {
      if (args.all) {
        context.commit('setUnread', 0)
      } else {
        context.commit('decUnread')
      }

      for (const ackedNotification of r.data) {
        const notification = context.state.notifications.find(notification => notification.notification_id === ackedNotification.notification_id)
        if (notification) {
          // TODO: check why reactivity is lost on read_at
          Vue.set(notification, 'read_at', ackedNotification.read_at)
          notification.isNew = false
        }
      }
    })
  },
}
